import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import MDBox from "components/MDBox";
import UiButton from "components/base/UiButton";
import UiInput from "components/base/UiInput";
import OrganizationProductTypeIdsOptions from "modules/OrganizationProductTypes/OrganizationProductTypeIdsOptions/OrganizationProductTypeIdsOptions";

type SaveWorksheetProductDialogProps = {
  open: boolean;
  loading?: boolean;
  productTypeId: string;
  onProductTypeIdChange: (value: string) => void;
  internalName: string;
  onInternalNameChange: (value: string) => void;
  onClose: () => void;
  onConfirm: () => void;
};

export default function SaveWorksheetProductDialog({
  open,
  loading,
  productTypeId,
  onProductTypeIdChange,
  internalName,
  onInternalNameChange,
  onClose,
  onConfirm,
}: SaveWorksheetProductDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Save as Product</DialogTitle>
      <DialogContent>
        <MDBox display="flex" flexDirection="column" gap="12px" pt="8px">
          <OrganizationProductTypeIdsOptions sortByName>
            {({ organizationProductTypeIdsOptions, loading: loadingTypes }) => (
              <FormControl fullWidth size="small" disabled={loadingTypes} required>
                <InputLabel id="save-product-type-label">Product Type</InputLabel>
                <Select
                  labelId="save-product-type-label"
                  label="Product Type"
                  value={productTypeId}
                  onChange={(event) => onProductTypeIdChange(event.target.value)}
                >
                  {organizationProductTypeIdsOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </OrganizationProductTypeIdsOptions>
          <UiInput
            value={internalName}
            placeholder="Internal name (optional)"
            onChange={(event) => onInternalNameChange(event.target.value)}
          />
        </MDBox>
      </DialogContent>
      <DialogActions>
        <UiButton uiVariant="outlined" onClick={onClose}>
          Cancel
        </UiButton>
        <UiButton uiVariant="primary-blue" disabled={!productTypeId || loading} onClick={onConfirm}>
          {loading ? "Saving..." : "Save Product"}
        </UiButton>
      </DialogActions>
    </Dialog>
  );
}
